import DateRange from "../DateRange";

export default class BaseSelectionType {
    accept(visitor, selectedRegion) {
        //should be implemented in inheritors
    }

    getSelectedData(lockTable, selectedRegion) {
        //should be implemented in inheritors
    }

    canBeLocked(lockTable, selectedRegion) {
        //should be implemented in inheritors
    }

    canBeUnlocked(lockTable, selectedRegion) {
        //should be implemented in inheritors
    }

    getSelectionDateRange(datesRow, selectedRegion) {
        var dateFrom = datesRow.getCell(selectedRegion.colMin).getValue().date;
        var dateTo = datesRow.getCell(selectedRegion.colMax).getValue().date;
        return new DateRange(dateFrom, dateTo);
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/BaseSelectionType.js